import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
	filtersFromSearch,
	filtersToSearch,
} from "src/helpers/searchFiltersUrl";

type State = Record<string, unknown>;

// filtry jawnie w query (?terms=1,2&starred=1); klucze spoza defaults (np. questionLabel) zostają w history state
export function useSearchFiltersState<T extends State>(defaults: T) {
	const location = useLocation<Partial<T> | undefined>();
	const history = useHistory();

	// biome-ignore lint/correctness/useExhaustiveDependencies: defaults are static per page
	const state = useMemo(
		() =>
			({
				...defaults,
				...location.state,
				...(location.search
					? filtersFromSearch(location.search, defaults)
					: {}),
			}) as T,
		[location.search, location.state],
	);

	const setState = (values: Partial<T>) => {
		const next = { ...state, ...values };
		const extra = Object.fromEntries(
			Object.entries(next).filter(([key]) => !(key in defaults)),
		);
		history.replace({
			pathname: location.pathname,
			search: filtersToSearch(next, defaults),
			state: extra,
		});
	};

	return [state, setState] as const;
}
